import { cloneDeep } from 'lodash-es';
import { makeAutoObservable, observable, runInAction } from 'mobx';

import { AdminUser } from '~hooks/admin/useUsersAdmin/models';
import { RootStore } from '~store/RootStore';

class UserAdminStore {
  user: AdminUser = {} as AdminUser;

  constructor(private readonly rootStore: RootStore) {
    makeAutoObservable(this, {
      user: observable,
    });
    this.rootStore = rootStore;
  }

  setUser(user: AdminUser) {
    runInAction(() => {
      this.user = cloneDeep(user);
    });
  }
}

export default UserAdminStore;
